import React, {useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import {GenericConfigurationForm, FormItem, validateFormData} from 'src/components/GenericConfigurationForm';

const items: Readonly<FormItem>[] = [
    {
        name: 'ame_method',
        humanReadableName: 'Enrichment test',
        description: 'Statistical test used to find enriched motifs',
        // longDescription: '',
        selects: [
            {value: 'fisher', label: 'Fisher'},
            {value: 'ranksum', label: 'Rank Sum'},
            {value: 'pearson', label: 'Pearson'},
            {value: 'spearman', label: 'Spearman'},
            {value: '3dmhg', label: '3D MHG'},
            {value: '4dmhg', label: '4D MHG'}
        ]
    },
    {
        name: 'nmotifs',
        humanReadableName: 'Number of motifs',
        description: 'DREME stops if it has found this many motifs',
        // longDescription: '',
        // todo: check if range is correct
        numbers: {
            min: 0,
            step: 1
        }
    },
    {
        name: 'e_val',
        humanReadableName: 'e value cutoff',
        description: 'Max E-value cutoff: the expected number of false positives',
        // longDescription: '',
        // todo: check if range is correct
        numbers: {
            min: 0,
            max: 1,
            step: 0.01
        }
    }
];

interface MotifParametersProps {
    formData: MotifFormData;
    setFormData: (data: any) => void;
    setValidForm: (isValid: boolean) => void;
}

const MotifParameters = ({formData, setFormData, setValidForm}: MotifParametersProps) => {
    const handleInputChange = (values: Record<string, any>) => {
        setFormData((prevData: any) => ({
            ...prevData,
            motif_analysis: {
                ...prevData.motif_analysis,
                ...values
            }
        }));
    };

    const [errors, setErrors] = useState<Record<string, string>>({});

    useEffect(() => {
        const newErrors = validateFormData(formData.motif_analysis, items);
        setErrors(newErrors);
        setValidForm(Object.keys(newErrors).length === 0);
    }, [formData, setValidForm]);

    return (
        <Box
            p={3}
            my={1}
            sx={{borderRadius: '10px', bgcolor: 'surface-container-lowest', display: 'flex', flexDirection: 'column', gap: 3}}>
            <GenericConfigurationForm
                items={items}
                itemValues={formData.motif_analysis}
                setItemValues={handleInputChange}
                itemErrors={errors}
            />
        </Box>
    );
};

export default MotifParameters;
